import { useEffect, useState } from 'preact/hooks'
import { Link } from '@/core'
import { AuthContent } from '@c/auth-app/auth-content'
import { useStore } from '@/core'
import { useRouter } from '@u'
import { useTranslation } from 'react-i18next'
import styles from './style.module.styl'

export const ConfirmEmployeeTypePage = () => {
  const { t } = useTranslation()
  const store = useStore()
  const router = useRouter()
  const [token] = store.use(['route', 'queries', 'token'])
  const [userId] = store.use(['route', 'queries', 'userId'])
  const [isError, setIsError] = useState(null)

  return (
    <>
      {(!token && !userId) || isError ? (
        <AuthContent
          title={'Awaiting Admin Approval'}
          extra={
            <Link name="login">
              {' '}
              {t('auth.confirmEmailPage.links.return_login')}
            </Link>
          }
        >
          {!isError ? (
            <>
              <p className={styles.detail}>
                Thanks for signing up!
              </p>
              <p className={styles.detail}>
                Once a Greenshield admin approves your account, you'll receive an email and will be able to login and start volunteering.
              </p>
            </>
          ) : (
            <p className={styles.detail}>{isError}</p>
          )}
        </AuthContent>
      ) : (
        <>
          <AuthContent
            title={t('auth.confirmEmailPage.titles.confirmed')}
            extra={
              <Link name="login">
                {t('auth.confirmEmailPage.links.return_login')}
              </Link>
            }
          >
            <p className={styles.detail}>
              {t('auth.confirmEmailPage.messages.login_complete')}
            </p>
          </AuthContent>
        </>
      )}
    </>
  )
}
